<template>
  <sfs-base-table
    :key="tableKey"
    :data-provider="$commissionsAPI.getLocationCommissions"
    :data-id="locationId"
    provider-key="commissions"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
    :append-to-query="false"
  >
    <template #cell(location_id)="data">
      <b-link
        :to="{ name: 'location', params: { id: data.item.location_id } }"
        v-b-tooltip.hover.window
        :title="`${data.item.location.street}, ${data.item.location.city}, ${data.item.location.state}, ${data.item.location.zip_code}`"
      >
        {{ data.item.location.store_number }}
      </b-link>
    </template>

    <template #cell(service_id)="data">
      <b-link :to="{ name: 'service', params: { id: data.item.service_id } }">
        {{ data.item.service.name }}
      </b-link>
    </template>

    <template #cell(commission_plan_id)="data">
      <div class="mb-1">
        <b-link :to="{ name: 'commission-plans', query: { text: data.item.commission_plan.name } }">
          {{ data.item.commission_plan.name }}
        </b-link>
      </div>
      <b-badge
        v-if="data.item.deleted_at"
        variant="danger"
        class="font-size-sm"
      >
        Inactive
      </b-badge>
    </template>

    <template #cell(start_date)="data">
      {{ data.item.start_date | dateFormat }}
      <div class="text-secondary font-size-sm">
        Ending {{ data.item.end_date | dateFormat }}
      </div>
    </template>

    <template #cell(actions)="data">
      <b-button-group>
        <b-button
          v-if="$can('destroy', 'Commission')"
          size="sm"
          variant="link"
          v-b-tooltip.hover.window
          :title="toggleActiveTooltipText(data.item)"
          @click="destroyCommissionDialog(data.item)"
        >
          <i
            v-if="!data.item.deleted_at"
            class="fa fa-fw fa-times mr-1"
          />
          <i
            v-else
            class="fa fa-fw fa-undo mr-1"
          />
        </b-button>
      </b-button-group>
    </template>
  </sfs-base-table>
</template>

<script>
import tablePropsMixin from '@/mixins/tablePropsMixin';
import { COMMISSION_TABLE_DEFAULT_COLUMNS } from '@/constants/commissions';
import { DateTime } from 'luxon';

export default {
  name: 'CommissionsTable',
  mixins: [tablePropsMixin],
  props: {
    locationId: {
      type: Number,
      required: true,
    },
    columns: {
      type: Array,
      default: () => COMMISSION_TABLE_DEFAULT_COLUMNS,
    },
  },
  methods: {
    destroyCommissionDialog(item) {
      this.$swal({
        text: this.toggleActiveConfirmText(item),
        preConfirm: () => this.$commissionsAPI.update(item.id, { deleted_at: !item.deleted_at ?  DateTime.now().toISODate() : null }),
      }).then((result) => {
        if (result.value) {
          this.refreshTable();
        }
        result.timer;
      });
    },
    toggleActiveTooltipText(item) {
      return !item.deleted_at ? 'Deactivate' : 'Reactivate';
    },
    toggleActiveConfirmText(item) {
      return !item.deleted_at
        ? 'Are you sure you want to deactivate the Commission?'
        : 'Are you sure you want to reactivate the Commission?';
    },
  },
};
</script>
